import { CommonModule, NgOptimizedImage } from '@angular/common';
import { NgModule } from '@angular/core';
import { MultiInputControlComponent } from 'shared/components/multi-input-control/multi-input-control.component';
import { PermissionDirective } from 'shared/directives/permission.directive';

import { BatchOperationsDashboardWidgetComponent } from 'dashboard/components/content-dashboard/batch-operations-dashboard-widget/batch-operations-dashboard-widget.component';
import { DownloadReportsDashboardWidgetComponent } from 'dashboard/components/content-dashboard/download-reports-dashboard-widget/download-reports-dashboard-widget.component';
import { ListStyleDashboardWidgetComponent } from 'dashboard/components/content-dashboard/list-style-dashboard-widget/list-style-dashboard-widget.component';
import { PieChartDashboardWidgetComponent } from 'dashboard/components/content-dashboard/pie-chart-dashboard-widget/pie-chart-dashboard-widget.component';
import { ScheduledChannelSnapshotsWidgetComponent } from 'dashboard/components/content-dashboard/scheduled-channel-snapshots-widget/scheduled-channel-snapshots-widget.component';
import {
    ScheduledReportsEditModalComponent,
    ScheduledReportsEmailSettingsModalComponent,
    ScheduledReportsSftpSettingsModalComponent,
} from 'dashboard/components/content-dashboard/scheduled-reports-dashboard-widget/modals';
import { ScheduledReportsDashboardWidgetComponent } from 'dashboard/components/content-dashboard/scheduled-reports-dashboard-widget/scheduled-reports-dashboard-widget.component';
import { ScheduledReportsRunStatusCellRendererComponent } from 'dashboard/components/content-dashboard/scheduled-reports-dashboard-widget/table-renderers';
import { ScheduledReportsFrequencyCellRendererComponent } from 'dashboard/components/content-dashboard/scheduled-reports-dashboard-widget/table-renderers/scheduled-reports-frequency-cell-renderer/scheduled-reports-frequency-cell-renderer.component';
import { NgxEchartsModule } from 'ngx-echarts';
import { SharedModule } from 'shared/shared.module';
import { DashboardComponent } from './components';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { DashboardService } from './services/dashboard.service';
import { ScheduledChannelSnapshotsService } from './services/scheduled-channel-snapshots.service';

@NgModule({
    declarations: [DashboardComponent, PieChartDashboardWidgetComponent, ListStyleDashboardWidgetComponent],
    imports: [
        CommonModule,
        DashboardRoutingModule,
        SharedModule,
        NgxEchartsModule.forRoot({
            echarts: () => import('echarts/core'),
        }),
        PermissionDirective,
        ScheduledReportsDashboardWidgetComponent,
        ScheduledReportsEditModalComponent,
        ScheduledReportsEmailSettingsModalComponent,
        ScheduledReportsRunStatusCellRendererComponent,
        ScheduledReportsSftpSettingsModalComponent,
        ScheduledReportsFrequencyCellRendererComponent,
        MultiInputControlComponent,
        DownloadReportsDashboardWidgetComponent,
        BatchOperationsDashboardWidgetComponent,
        NgOptimizedImage,
        ScheduledChannelSnapshotsWidgetComponent,
    ],
    providers: [DashboardService, ScheduledChannelSnapshotsService],
})
export class DashboardModule {}
